import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuComponent } from './menu/menu.component';
import { DashboardNavbar } from './dashboard-nav/dashboard-nav.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MapService, NgxMapboxGLModule } from 'ngx-mapbox-gl';

import { HomeComponent } from './home/home.component';
import { DriversComponent } from './drivers/drivers.component';
import {AvatarModule} from 'ngx-avatar';
import { TablesComponent } from './tables/tables.component';
import { BusComponent } from './bus/bus.component';
import { TripLineComponent } from './trip-line/trip-line.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { NewsComponent } from './news/news.component';
import {GoogleMapsModule} from 'google-maps-angular2';
import { MapComponent } from './map/map.component';
import { TestComponent } from './test/test.component';
import { SearchPipe } from './search.pipe';
import { SettingsComponent } from './settings/settings.component';
import { AllNewsComponent } from './all-news/all-news.component';
import { LoginComponent } from './login/login.component';
import {LiveLocationComponent} from './live-location/live-location.component';
import { SisCodeComponent } from './sis-code/sis-code.component';
import {AgmCoreModule} from '@agm/core';
import {NgxPaginationModule} from 'ngx-pagination';
import { MangeTravelComponent } from './mange-travel/mange-travel.component';
import { HomePageComponent } from './home-page/home-page.component';
import { PrivacyComponent } from './privacy/privacy.component';

const avatarColors = ['#FFB6C1', '#2c3e50', '#95a5a6', '#f39c12', '#1abc9c'];

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    DashboardNavbar,
    HomeComponent,
    DriversComponent,
    TablesComponent,
    BusComponent,
    TripLineComponent,
    SubscriptionComponent,
    NewsComponent,
    MapComponent,
    TestComponent,
    SearchPipe,
    SettingsComponent,
    AllNewsComponent,
    LoginComponent,
    LiveLocationComponent,
    SisCodeComponent,
    MangeTravelComponent,
    HomePageComponent,
    PrivacyComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AvatarModule,
    ReactiveFormsModule,
    GoogleMapsModule.forRoot({
      url: 'https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyDRKilpWtqtQVT_JP5O2HI1ptqtUjtwQQA'
    }),
    AgmCoreModule.forRoot({
      // please get your own API key here:
      // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en
      apiKey: 'AIzaSyDRKilpWtqtQVT_JP5O2HI1ptqtUjtwQQA',
      libraries: ["places"]
    }),
    NgxPaginationModule,
    NgxMapboxGLModule.withConfig({
      accessToken: 'pk.eyJ1IjoiaGFzYW4xOTk1IiwiYSI6ImNrNXNrODM1YzBiOXQzbHE3Y3NnMTF6NzMifQ.Hh-BnpbLElI5uPihfO_5VQ', // Optional, can also be set per map (accessToken input of mgl-map)
    })
  ],
  bootstrap: [AppComponent],
  providers:[MapService],
})
export class AppModule { }
